import React, { useEffect } from "react";
import AddToCalendar from "@culturehq/add-to-calendar";
import '@culturehq/add-to-calendar/dist/styles.css';

const Calendars = () => {
    useEffect(() => {
        const svgCalendar = document.querySelectorAll('.chq-atc--button');
        svgCalendar.forEach(item => {
            item.innerHTML = `<svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.90625 26.5342V3.47476H4.74949V0.912598H7.31165V3.47476H17.5603V0.912598H20.1224V3.47476H23.9657V26.5342H0.90625ZM3.46841 23.972H21.4035V11.1612H3.46841V23.972ZM3.46841 8.59907H21.4035V6.03691H3.46841V8.59907ZM3.46841 8.59907V6.03691V8.59907Z" fill="#A7A7A7" />
            <path d="M12.4863 12.499V22.4411" stroke="#A7A7A7" stroke-width="2" />
            <path d="M17.457 17.4702L7.51491 17.4702" stroke="#A7A7A7" stroke-width="2" />
          </svg>
          <span>Add</span>`;
        })
    });

    return (
        <AddToCalendar
            event={{
                name: "Ruby on Rails Global Summit'23",
                details: "",
                location: "London",
                startsAt: "2023-01-24T10:00:00",
                endsAt: "2023-01-25T23:00:00"
            }}
            children='Add'
        />
    );
}

export default Calendars;
